import React, {useState} from 'react'
import axios from 'axios'
import ReactHtmlParser from 'react-html-parser'
import CompareCheckbox from "../compare/CompareCheckbox"
import CompareGoButton from "../compare/CompareGoButton"
import isProd from "../../utils/constants/isProd";
import searchParams from "../../utils/constants/searchParams";

const ModalInfo = ({articleBrandParts, title, brand, article, isModalActive, setIsModalActive, activeTab}) => {
    const [info, setInfo] = useState(false)

    const [toggleState, setToggleState] = useState(activeTab)

    const toggleTab = (index) => {
        setToggleState(index)
    }

    if (isModalActive && !info) {
        if (isProd) {
            axios
                .get(
                    `/bitrix/services/main/ajax.php?action=bosjack:searchlm.api.part.getInfo&brand=${encodeURIComponent(
                        brand
                    )}&article=${encodeURIComponent(article)}`
                )
                .then((res) => {
                    if (res.data.status === 'success') {
                        res.data.data.props = res.data.data.props.filter((prop) => {
                            return (
                                (prop['value'] !== '' && prop['value'] !== null)
                            )
                        })

                        setInfo(res.data.data)
                    }
                })
        } else {
            setInfo(
                {
                    article: article,
                    brand_title: brand,
                    image: null,
                    brand:
                        {
                            name: brand,
                            image: null,
                            text: 'Российский завод «Цитрон» выпускает обширный ассортимент фильтров под товарным знаком «TSN»: воздушные, масляные, топливные фильтры для инжекторных двигателей и дизелей, фильтры для гидравлических и пневматических систем, салонные фильтры и прочие запасные части для иномарок и отечественных авто.<br><br>Страна происхождения: Россия.<br>Год основания: 1991 г.<br><br>Сертификат: ISO 9001, а также была испытана в институте НАМИ.'
                        },
                    props: [
                        {
                            name: 'Вид',
                            value: 'Фильтр масляный'
                        },
                        {
                            name: 'Категория',
                            value: 'Масляный фильтр'
                        },
                        {
                            name: 'Наружный диаметр OD1, мм',
                            value: '76'
                        },
                        {
                            name: 'Длина L, мм',
                            value: '82'
                        },
                        {
                            name: 'Резьба',
                            value: 'M18 x 1,5'
                        },
                        {
                            name: 'Прочие характеристики',
                            value: 'Применяемость: OPEL CHEVROLET DAEWOO. Особенности: Коробка, без клапанов Брутто: 0,29 кг'
                        }
                    ],
                    url: '/',
                    rel_products: [
                        {
                            article: 'oc90',
                            brand: 'MAHLE',
                            title: 'Описание товара',
                            image: null,
                            url: "/"
                        },
                        {
                            article: 'oc90',
                            brand: 'MAHLE',
                            title: 'Описание товара',
                            image: null,
                            url: "/"
                        },
                        {
                            article: 'oc90',
                            brand: 'MAHLE',
                            title: 'Описание товара',
                            image: null,
                            url: "/"
                        }
                    ]
                }
            )
        }
    }

    return (
        <div
            className={isModalActive ? 'modal-product-info active' : 'modal-product-info'}
            onClick={() => setIsModalActive(false)}
        >
            <div className="modal__content" onClick={(e) => e.stopPropagation()}>
                <svg
                    onClick={() => setIsModalActive(false)}
                    className="modal__close"
                    width="10"
                    height="10"
                    viewBox="0 0 10 10"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M9.66634 1.27333L8.72634 0.333328L4.99967 4.06L1.27301 0.333328L0.333008 1.27333L4.05967 5L0.333008 8.72666L1.27301 9.66666L4.99967 5.93999L8.72634 9.66666L9.66634 8.72666L5.93967 5L9.66634 1.27333Z"
                        fill="black"
                    />
                </svg>
                <div className="product-info">
                    <div className="product-info__brand-article">
                        {info.article} {info.brand_title}
                    </div>
                    <div className="product-info__name">{title}</div>
                    <div className="tabs-wrapper">
                        <div className="bloc-tabs">
                            <button
                                className={
                                    toggleState === 1 ? 'button-tab active-tab' : 'button-tab'
                                }
                                onClick={() => toggleTab(1)}
                            >
                                О товаре
                            </button>
                            {info.brand ? (
                                <button
                                    className={
                                        toggleState === 2 ? 'button-tab active-tab' : 'button-tab'
                                    }
                                    onClick={() => toggleTab(2)}
                                >
                                    Производитель
                                </button>
                            ) : (
                                <></>
                            )}
                            {articleBrandParts.is_rel_products ? (
                                <button
                                    className={
                                        toggleState === 3 ? 'button-tab active-tab' : 'button-tab'
                                    }
                                    onClick={() => toggleTab(3)}
                                >
                                    Связанные товары
                                </button>
                            ) : (
                                <></>
                            )}


                        </div>

                        <div className="content-tabs">
                            <div
                                className={
                                    toggleState === 1 ? 'content  active-content' : 'content'
                                }
                            >
                                <div className="product__about">
                                    <div className="product__about-image">
                                        <div className="image__wrapper">
                                            {info.image ? (
                                                <img src={info.image} alt=""/>
                                            ) : (
                                                <svg
                                                    width="28"
                                                    height="25"
                                                    viewBox="0 0 28 25"
                                                    fill="none"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                >
                                                    <path
                                                        d="M24.6665 3.33332H20.4398L17.9998 0.666656H9.99984L7.55984 3.33332H3.33317C1.8665 3.33332 0.666504 4.53332 0.666504 5.99999V22C0.666504 23.4667 1.8665 24.6667 3.33317 24.6667H24.6665C26.1332 24.6667 27.3332 23.4667 27.3332 22V5.99999C27.3332 4.53332 26.1332 3.33332 24.6665 3.33332ZM24.6665 22H3.33317V5.99999H8.73317L11.1732 3.33332H16.8265L19.2665 5.99999H24.6665V22ZM13.9998 7.33332C10.3198 7.33332 7.33317 10.32 7.33317 14C7.33317 17.68 10.3198 20.6667 13.9998 20.6667C17.6798 20.6667 20.6665 17.68 20.6665 14C20.6665 10.32 17.6798 7.33332 13.9998 7.33332ZM13.9998 18C11.7998 18 9.99984 16.2 9.99984 14C9.99984 11.8 11.7998 9.99999 13.9998 9.99999C16.1998 9.99999 17.9998 11.8 17.9998 14C17.9998 16.2 16.1998 18 13.9998 18Z"
                                                        fill="#DADADA"
                                                    />
                                                </svg>
                                            )}
                                        </div>
                                        <div className="product-info__compare">
                                            {articleBrandParts.is_ib_element ?
                                                (<>
                                                        <CompareCheckbox
                                                            part_id={articleBrandParts.part_id}
                                                            hash={articleBrandParts.notepad_hash}
                                                            article={articleBrandParts.original_article}
                                                            brand={articleBrandParts.brand_title}
                                                        />
                                                        <CompareGoButton/>
                                                    </>
                                                ) :
                                                (
                                                    <></>
                                                )
                                            }
                                        </div>
                                    </div>
                                    <div className="product__about-props">
                                        {info.props ? (
                                            info.props.map((prop) => (
                                                <div
                                                    className="product__about-prop"
                                                    key={prop.name}
                                                >
                                                    <div className="props__name">{prop.name}</div>
                                                    <div className="props__value">
                                                        <div>
                                                            {ReactHtmlParser(
                                                                prop.value.replaceAll(
                                                                    /;/g,
                                                                    '<br />'
                                                                )
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            ))
                                        ) : (
                                            <></>
                                        )}
                                        {info.url ? (
                                            <>
                                                <div className="hr"></div>
                                                <a href={info.url} className="product-info__detail">
                                                    Перейти в карточку
                                                    <svg
                                                        width="12"
                                                        height="8"
                                                        viewBox="0 0 12 8"
                                                        fill="none"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                    >
                                                        <path
                                                            d="M6 0L0 6L1.41 7.41L6 2.83L10.59 7.41L12 6L6 0Z"
                                                            fill="black"
                                                        />
                                                    </svg>
                                                </a>
                                            </>
                                        ) : (
                                            <></>
                                        )}
                                    </div>
                                </div>
                            </div>
                            {info.brand ? (
                                <div
                                    className={
                                        toggleState === 2 ? 'content  active-content' : 'content'
                                    }
                                >
                                    <div className="product__about">
                                        <div className="product__about-image">
                                            <div className="image__wrapper">
                                                {info.brand.image ? (
                                                    <img src={info.brand.image} alt=""/>
                                                ) : (
                                                    <svg
                                                        width="28"
                                                        height="25"
                                                        viewBox="0 0 28 25"
                                                        fill="none"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                    >
                                                        <path
                                                            d="M24.6665 3.33332H20.4398L17.9998 0.666656H9.99984L7.55984 3.33332H3.33317C1.8665 3.33332 0.666504 4.53332 0.666504 5.99999V22C0.666504 23.4667 1.8665 24.6667 3.33317 24.6667H24.6665C26.1332 24.6667 27.3332 23.4667 27.3332 22V5.99999C27.3332 4.53332 26.1332 3.33332 24.6665 3.33332ZM24.6665 22H3.33317V5.99999H8.73317L11.1732 3.33332H16.8265L19.2665 5.99999H24.6665V22ZM13.9998 7.33332C10.3198 7.33332 7.33317 10.32 7.33317 14C7.33317 17.68 10.3198 20.6667 13.9998 20.6667C17.6798 20.6667 20.6665 17.68 20.6665 14C20.6665 10.32 17.6798 7.33332 13.9998 7.33332ZM13.9998 18C11.7998 18 9.99984 16.2 9.99984 14C9.99984 11.8 11.7998 9.99999 13.9998 9.99999C16.1998 9.99999 17.9998 11.8 17.9998 14C17.9998 16.2 16.1998 18 13.9998 18Z"
                                                            fill="#DADADA"
                                                        />
                                                    </svg>
                                                )}
                                            </div>
                                        </div>
                                        <div className="product__brand-text">
                                            <div
                                                dangerouslySetInnerHTML={{
                                                    __html: info.brand.text
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                <></>
                            )}
                            {info.rel_products ? (
                                <div
                                    className={`content rel-products${toggleState === 3 ? ' active-content' : ''}`}
                                >
                                    <span className="text">{searchParams["TEXT_REL_PRODUCTS"]}</span>
                                    {info.rel_products.map((product) => (
                                        <div className="result-table__info brand-article">
                                            <div className="result-table__info-image">
                                                <div className="result-table__info-image-wrapper">
                                                    <a href={product.url}>
                                                        {product.image ? (
                                                            <img src={product.image} alt={product.title} />
                                                        ) : (
                                                            <svg
                                                                width="28"
                                                                height="25"
                                                                viewBox="0 0 28 25"
                                                                fill="none"
                                                                xmlns="http://www.w3.org/2000/svg"
                                                            >
                                                                <path
                                                                    d="M24.6665 3.33332H20.4398L17.9998 0.666656H9.99984L7.55984 3.33332H3.33317C1.8665 3.33332 0.666504 4.53332 0.666504 5.99999V22C0.666504 23.4667 1.8665 24.6667 3.33317 24.6667H24.6665C26.1332 24.6667 27.3332 23.4667 27.3332 22V5.99999C27.3332 4.53332 26.1332 3.33332 24.6665 3.33332ZM24.6665 22H3.33317V5.99999H8.73317L11.1732 3.33332H16.8265L19.2665 5.99999H24.6665V22ZM13.9998 7.33332C10.3198 7.33332 7.33317 10.32 7.33317 14C7.33317 17.68 10.3198 20.6667 13.9998 20.6667C17.6798 20.6667 20.6665 17.68 20.6665 14C20.6665 10.32 17.6798 7.33332 13.9998 7.33332ZM13.9998 18C11.7998 18 9.99984 16.2 9.99984 14C9.99984 11.8 11.7998 9.99999 13.9998 9.99999C16.1998 9.99999 17.9998 11.8 17.9998 14C17.9998 16.2 16.1998 18 13.9998 18Z"
                                                                    fill="#DADADA"
                                                                />
                                                            </svg>
                                                        )}
                                                    </a>
                                                </div>
                                            </div>
                                            <div className="result-table__info-text">
                                                <div className="result-table__info-ba">
                                                <span className="result-table__info-brand">
                                                    <span>{product.brand}</span>
                                                </span>
                                                    <a
                                                        className="result-table__info-article"
                                                        href={`/auto/search/${encodeURIComponent(
                                                            product.article_cleared
                                                        )}/?brand_title=${encodeURIComponent(
                                                            product.brand
                                                        )}`}
                                                        target="_blank">{product.article}</a>
                                                </div>
                                                <div className="result-table__info-description">{product.title}</div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            ) : (
                                <></>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ModalInfo
